'use strict';

var _ = require('lodash');
var AppliedStrategyPanelController = function AppliedStrategyPanelController($scope, elementServiceProvider, Strategy, StrategyConstants, dataRetrieverConstantsService, dataRetrieverService, featureToggleService, statementBoxService, restangular) {
  $scope.strategiesPanelVisible = false;
  $scope.wasNewGridDataLoaded = false;
  $scope.preselectedRowsReadyForCheck = false;
  $scope.appliedStrategiesMode = $scope.rule.type === StrategyConstants.PANEL_TYPE.ALERTS ? dataRetrieverConstantsService.RULE_CUSTOM_STRATEGY_LISTING_ALERTS : dataRetrieverConstantsService.RULE_CUSTOM_STRATEGY_LISTING;
  $scope.rowDetailsTemplate = '<rm-strategy-row-details strategy-details-data="rowData"></rm-strategy-row-details>';
  var dataRetriever = dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.RULE_SCREEN, $scope.appliedStrategiesMode).setCustomSearchCriteriaRules([]);
  function parseRuleFlowType(flowType) {
    return flowType && flowType.replace(/FlowType./g, '');
  }
  function getExclusionFlowType() {
    var flowTypes = _.filter(StrategyConstants.FlowType, function (val) {
      return val !== $scope.rule.flowType;
    });
    return _.map(flowTypes, parseRuleFlowType);
  }
  function setAdditionalParametersToDataRetriever() {
    dataRetriever.updateAdditionalParameters({
      flowTypeToExclude: $scope.rule.flowType ? getExclusionFlowType() : undefined
    });
  }
  function isMappedModeEnabled() {
    return featureToggleService.isEnabled('MAPPED_MODE');
  }
  function isStrategyCorrectFlowType(strategy) {
    return strategy.flowType === $scope.rule.flowType || !strategy.flowType;
  }
  function filterStrategiesByDemandType() {
    if ($scope.rule.flowType && _.isArray($scope.rule.appliedStrategies) && $scope.rule.appliedStrategies.length > 0) {
      $scope.rule.appliedStrategies = _.filter($scope.rule.appliedStrategies, isStrategyCorrectFlowType);
    }
  }
  if (isMappedModeEnabled()) {
    setAdditionalParametersToDataRetriever();
    $scope.$on('ruleCustom:updateStrategiesGrid', function () {
      setAdditionalParametersToDataRetriever();
      filterStrategiesByDemandType();
      if ($scope.strategiesPanelVisible) {
        $scope.$broadcast('grid:clearAndLoadData:rule-custom-strategy-listing');
      }
    });
  }
  $scope.hideStrategiesPanel = function () {
    $scope.strategiesPanelVisible = false;
    $scope.preselectedRowsReadyForCheck = false;
  };
  $scope.appliedStrategiesElementService = elementServiceProvider.getInstance({
    preAddingNewElementHook: function preAddingNewElementHook() {
      $scope.strategiesPanelVisible = true;
      return false;
    },
    postRemovingElementHook: function postRemovingElementHook(removedElement) {
      $scope.$broadcast('grid:unSelectRows', [{
        technicalId: removedElement.technicalId
      }]);
    },
    getCollection: function getCollection() {
      return $scope.rule && $scope.rule.appliedStrategies;
    }
  });
  $scope.selectStrategy = function (elem) {
    if (!$scope.isStrategySelected(elem)) {
      $scope.isBoxVisible = false;
    }
    $scope.appliedStrategiesElementService.selectElement(elem);
  };
  $scope.isStrategySelected = $scope.appliedStrategiesElementService.isElementSelected;

  /**
   * Grid selection change handler
   * @param event event name
   * @param selection array of Strategy objects representing the current selection on the grid
   */
  $scope.selectionChanged = function (event, selection) {
    // we are ignoring first selection changed after new grid data loaded
    if ($scope.wasNewGridDataLoaded) {
      $scope.wasNewGridDataLoaded = false;
      return;
    }

    // so chosen strategies won't be cleared on open, when empty selection it triggered by grid
    if ($scope.preselectedRowsReadyForCheck === false) {
      if (selection.length === 0) {
        return;
      } else if (selection.length > 0) {
        $scope.preselectedRowsReadyForCheck = true;
      }
    }

    // first we remove strategies which were unselected
    _.forEachRight($scope.rule.appliedStrategies, function (el, i, arr) {
      if (!_.find(selection, {
        technicalId: el.technicalId
      })) {
        arr.splice(i, 1);
      }
    });
    if (!$scope.rule.appliedStrategies) {
      $scope.rule.appliedStrategies = [];
    }

    // secondly we push newly selected strategies
    selection.forEach(function (el) {
      if (!_.find($scope.rule.appliedStrategies, {
        technicalId: el.technicalId
      })) {
        $scope.rule.appliedStrategies.push(new Strategy(el));
      }
    });
  };

  /**
   * New grid data loaded handler.
   * Jqx grid cleares selection on showing the grid, that's why we must set it again
   */
  $scope.newGridDataLoaded = function () {
    var ids = _.map($scope.rule.appliedStrategies, function (s) {
      return {
        technicalId: s.technicalId
      };
    });
    if (ids.length) {
      $scope.wasNewGridDataLoaded = true;
      $scope.$broadcast('grid:clearAndSelect:rule-custom-strategy-listing', ids);
    }
  };
  $scope.toggleStatement = function (strategy) {
    if (_.isUndefined(strategy.isVisible)) {
      var rulesSearchAPI = restangular.one('rules').all('strategy');
      rulesSearchAPI.get('?filter=name=="' + encodeURIComponent(strategy.name) + '"').then(function (response) {
        var detailedStrategy = response.results[0];
        strategy.isVisible = true;
        strategy.details = detailedStrategy;
      });
    } else {
      strategy.isVisible = !strategy.isVisible;
    }
  };
};
AppliedStrategyPanelController.$inject = ['$scope', 'ElementServiceProvider', 'StrategyFactory', 'StrategyConstants', 'DataRetrieverConstantsService', 'DataRetrieverService', 'FeatureToggleService', 'StatementBoxService', 'Restangular'];
module.exports = AppliedStrategyPanelController;